import { render, staticRenderFns } from "./FullscreenModal.vue?vue&type=template&id=8b827652&scoped=true&"
import script from "./FullscreenModal.vue?vue&type=script&lang=ts&"
export * from "./FullscreenModal.vue?vue&type=script&lang=ts&"
import style0 from "./FullscreenModal.vue?vue&type=style&index=0&id=8b827652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b827652",
  null
  
)

component.options.__file = "FullscreenModal.vue"
export default component.exports